<template>
  <v-dialog v-model="showDialog" persistent max-width="500px">
    <v-card v-if="!subscriptionRenewed">
      <v-card-title
        ><div
          class="d-flex align-center"
          ><h1>We'd Love To Have You Back</h1>
          <v-spacer /><v-progress-circular
            v-show="loading"
            :active="true"
            :indeterminate="true"
            size="25"
            width="2"
            class="mr-1"
          />
          <v-btn icon variant="plain" @click="handleCancel" :disabled="loading"
            ><v-icon icon="close" /></v-btn
          ></div></v-card-title
      >
      <v-divider />
      <v-card-text>
        <div class="text-h6">
          With your subscription bundle, your montly cost would be ${{
            salesPriceFormat(totalSubscriptionCost)
          }}.
          <br />
          <br />
          Renew and get selling!
        </div>
      </v-card-text>
      <v-card-actions class="py-3 px-3">
        <v-btn variant="flat" @click="handleCancel" :disabled="loading">
          Go back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          variant="flat"
          :disabled="loading"
          @click="handleSubmit"
          data-testid="confirm-renew-subscription"
          color="primary"
          class="text-white"
        >
          Renew Subscription
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title
        ><div
          class="d-flex align-center"
          ><h1>Welcome Back to ThreadFlow!</h1>
          <v-spacer /><v-progress-circular
            v-show="loading"
            :active="true"
            :indeterminate="true"
            size="25"
            width="2"
          /> </div></v-card-title>
      <v-divider />
      <v-card-text />
      <v-card-actions class="py-3 px-3">
        <v-spacer></v-spacer>
        <v-btn
          variant="flat"
          @click="handleCancel"
          color="primary"
          class="text-white"
        >
          okay
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { describeError } from "@/utils/safeErrorLog";
import rules from "@/mixins/rules";
import helpers from "@/mixins/helpers";
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import { notifyPaymentsChanged } from "@/stores/sidebarRefresh";

export default {
  name: "RenewSubscriptionDialog",

  props: {
    subscription: {},
    distributor_id: {
      type: Number,
    },
  },
  computed: {
    totalSubscriptionCost() {
      let total = 0;
      if (this.subscription && this.subscription.accounts && Array.isArray(this.subscription.accounts)) {
        this.subscription.accounts.forEach((account) => {
          if (account.active || account.status == "invited") {
            total += account.unit_amount || 0;
          }
        });
      }
      return total;
    },
  },

  mixins: [helpers, rules],

  data() {
    return {
      showDialog: false,
      loading: false,
      subscriptionRenewed: false,
    };
  },
  mounted() {},
  methods: {
    show() {
      this.showDialog = true;
    },

    handleCancel() {
      if (this.subscriptionRenewed) {
        this.$emit("renew-subscription");
      }
      this.showDialog = false;
      this.subscriptionRenewed = false;
    },

    async handleSubmit() {
      await this.renewSubscription();
    },

    async renewSubscription() {
      this.loading = true;
      let response;
      try {
        response = await this.$axios.post(`/subscription/renewSubscription/`, {
          user_id: this.$store.state.account._jv.id,
          source: "distributor",
          distributor_id: this.distributor_id,
          subscription: this.subscription,
        });
      } catch (err) {
        console.log(describeError(err));
        this.$store.dispatch("raiseError", err);
        return false;
      } finally {
        // On the failure path the catch has already returned, but ``finally``
        // still runs -- and ``response`` is undefined there, so guard it before
        // reading ``.data`` (a bare ``response.data.error`` used to throw on
        // every failed renew).
        if (response && response.data && response.data.error) {
          console.log(response.data.error);
        } else if (response) {
          this.subscriptionRenewed = true;
          // Renewing moves the subscription STATE + trial, which the payments
          // sidebar row reads (derive_payments_summary) -> refresh it. Only the
          // success branch reaches here (a failed POST leaves ``response``
          // undefined). Interim seam (https://trello.com/c/g9K52FsA).
          notifyPaymentsChanged();
        }
        this.loading = false;
      }
    },
  },
};
</script>
<style scope></style>
